module.exports = __webpack_public_path__ + "img/gestao.4d20d278.png";